<template>
  <div
    :class="[
      ns.b('dropdown'),
      ns.is('multiple', isMultiple),
      popperClass,
      ns.bm('dropdown', size),
    ]"
    :style="{
      [isFitInputWidth ? 'width' : 'minWidth']: minWidth,
      maxWidth: dropdownMaxWidth,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, onMounted, ref } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import { useNamespace } from '@jdesign-vue/hooks'
import { selectKey } from './token'

export default defineComponent({
  name: 'JdSelectDropdown',

  componentName: 'JdSelectDropdown',

  setup() {
    const select = inject(selectKey)!
    const ns = useNamespace('select')

    // computed
    const popperClass = computed(() => select.props.popperClass)
    const isMultiple = computed(() => select.props.multiple)
    const isFitInputWidth = computed(() => select.props.fitInputWidth)
    const wrapSelected = computed(() => select.props.wrapSelected)
    const size = computed(() => select.props.size)
    const minWidth = ref('')
    const dropdownMaxWidth = ref('')

    function updateMinWidth() {
      minWidth.value = `${select.selectWrapper?.offsetWidth}px`
    }
    function updateMaxWidth() {
      if (wrapSelected.value) {
        const extWidth = select.props.dropdownMaxWidth || 0
        dropdownMaxWidth.value =`${ select.selectWrapper?.offsetWidth + extWidth }px`
      }
    }
    function updateWidth() {
      updateMinWidth()
      updateMaxWidth()
    }
    onMounted(() => {
      // TODO: updatePopper
      // popper.value.update()
      updateWidth()
      useResizeObserver(select.selectWrapper, updateWidth)
    })

    return {
      ns,
      size,
      minWidth,
      popperClass,
      isMultiple,
      isFitInputWidth,
      wrapSelected,
      dropdownMaxWidth,
    }
  },
})
</script>
